import FootballStatsCategory from "../../stats/football-stats-category";
import StatsRule from "../../../common/stats-rule";

export default class TouchdownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const {
            fieldPosition,
            homeTeamId,
            awayTeamId,
            gameConfig,
            homeTeamHasPossession
        } = gameContext;

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: homeTeamHasPossession ? homeTeamId : awayTeamId,
            playerId: null,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.TOUCHDOWN,
            values: {
                completed: 1
            }
        });
    }
}
